import React from 'react';
import PropTypes from 'prop-types';
import TransactionForm from '../../../../components/TransactionForm';
import DataGridPreview from '@afosto/app-components-react/DataGrid/DataGridPreview';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';

const TransactionPreview = ({
  transaction,
  isOpen,
  isLoading,
  previewMenu,
  onClose,
  onSaveTransaction,
}) => (
  <DataGridPreview title={transaction?.number} menu={previewMenu} open={isOpen} onClose={onClose}>
    <LoadingWrapper isLoading={isLoading} style={{ minHeight: 200 }}>
      {transaction && (
        <TransactionForm
          transaction={transaction}
          onSubmit={onSaveTransaction}
          onCancel={onClose}
          inline
        />
      )}
    </LoadingWrapper>
  </DataGridPreview>
);

TransactionPreview.propTypes = {
  transaction: PropTypes.object,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  previewMenu: PropTypes.array,
  onClose: PropTypes.func,
  onSaveTransaction: PropTypes.func,
};

TransactionPreview.defaultProps = {
  transaction: null,
  isOpen: false,
  isLoading: false,
  previewMenu: [],
  onClose: undefined,
  onSaveTransaction: undefined,
};

export default TransactionPreview;
